import {Fragment} from "react";
import {Box, Field, Stack, Text} from "@chakra-ui/react";
import Select from "react-select";
import {useHandleFrequency} from "../../hooks/useHandleFrequency";
import {useHandleOs} from "../../hooks/useHandleOs";
import {useHandlePlan} from "../../hooks/useHandlePlan";
import {dropdownStyles} from "./dropdownStyles";
import Overview from "./overview";
import Navigation from "./navigation";

const SelectComponents = ({
  handlePlanChange,
  planOptions,
  selectedPlan,
  osOptions,
  handleOsChange,
  selectedOS,
  frequencyOptions,
  handleFrequencyChange,
  selectedFrequency,
}) => {
  return (
    <Box
      display={"grid"}
      gridTemplateColumns={{
        base: "1fr",
        sm: "1fr",
        md: "1fr 1fr",
        xl: "1.5fr 1.5fr 1fr",
      }}
      gridGap={"0.5rem"}
    >
      <Field.Root data-cy="package">
        <Text>Package</Text>
        <Box>
          <Select
            value={selectedPlan}
            placeholder={"select..."}
            options={planOptions}
            onChange={handlePlanChange}
            styles={dropdownStyles}
            menuPlacement="top"
            isSearchable={false}
            getOptionLabel={(option) => <PackageOption option={option} />}
          />
        </Box>
      </Field.Root>
      {selectedPlan.name !== "Custom" && (
        <Fragment>
          <Field.Root data-cy="operating-system">
            <Text fontSize={"14px"}>Operating System</Text>
            <Box>
              <Select
                value={selectedOS}
                placeholder={"select..."}
                options={osOptions}
                onChange={handleOsChange}
                styles={dropdownStyles}
                menuPlacement="top"
                isSearchable={false}
                getOptionLabel={(option) => option.name}
              />
            </Box>
          </Field.Root>
          <Field.Root data-cy="billing-cycle">
            <Text>Billing Cycle</Text>
            <Box>
              <Select
                value={selectedFrequency}
                placeholder={"select..."}
                options={frequencyOptions}
                onChange={handleFrequencyChange}
                styles={dropdownStyles}
                menuPlacement="top"
                isSearchable={false}
              />
            </Box>
          </Field.Root>
        </Fragment>
      )}
    </Box>
  );
};

const ProductModalFooter = (props) => {
  const {onClose} = props;
  const {handlePlanChange, planOptions, planType, selectedPlan} = useHandlePlan();
  const {osOptions, handleOsChange, selectedOS} = useHandleOs(planType);
  const {frequencyOptions, handleFrequencyChange, selectedFrequency} =
    useHandleFrequency(selectedOS);

  return (
    <div>
      <Box
        minH={"40px"}
        color={"#16191f"}
        display={"grid"}
        gridTemplateColumns={{
          base: "1fr",
          sm: "1fr",
          md: "1fr",
          lg: "1fr 2.25fr",
        }}
        alignItems={"baseline"}
        justifyContent={"space-between"}
        margin={"0.5rem 0 0 0"}
        fontSize={"14px"}
        padding={{
          base: "0 1rem",
          sm: "0 1rem",
          md: "0 1rem",
          lg: "1rem 1rem 0 1rem",
        }}
      >
        <Box display={{base: "none", lg: "flex"}}>
          <Box paddingRight={3} borderRight={".2rem solid #d5dbdb"}>
            <Overview
              planType={planType}
              selectedPlan={selectedPlan}
              selectedFrequency={selectedFrequency}
              selectedOS={selectedOS}
            />
          </Box>
        </Box>
        <SelectComponents
          handlePlanChange={handlePlanChange}
          planOptions={planOptions}
          selectedPlan={selectedPlan}
          osOptions={osOptions}
          handleOsChange={handleOsChange}
          selectedOS={selectedOS}
          frequencyOptions={frequencyOptions}
          handleFrequencyChange={handleFrequencyChange}
          selectedFrequency={selectedFrequency}
        />
        <Box display={{lg: "none"}} marginTop={2}>
          <Overview
            planType={planType}
            selectedPlan={selectedPlan}
            selectedFrequency={selectedFrequency}
            selectedOS={selectedOS}
          />
        </Box>
      </Box>
      <Navigation
        planType={planType}
        selectedPlan={selectedPlan}
        selectedFrequency={selectedFrequency}
        selectedOS={selectedOS}
        onClose={onClose}
      />
    </div>
  );
};

export default ProductModalFooter;

const PackageOption = ({option = {}}) => {
  if (option.name === "Custom") {
    return "Custom";
  }
  const {clusterSize, config = {}} = option;
  const {memory, memory_unit, num_ssd = 1, ssd, ssd_unit, vcpu} = config;
  return (
    <Stack spacing={1}>
      <Text>{option.name}</Text>
      {clusterSize && <Text fontSize={"12px"}>{`Cluster Size : ${clusterSize}.`}</Text>}
      <Text
        fontSize={"12px"}
      >{`CPU : ${vcpu}. RAM : ${memory} ${memory_unit}. SSD : ${num_ssd} x ${ssd} ${ssd_unit}`}</Text>
    </Stack>
  );
};
